var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDecrease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6669 17C19.8508 16.9998 19.9997 16.8508 19.9999 16.667V13.1377C19.9997 12.9539 19.8507 12.8049 19.6669 12.8047C19.5785 12.8047 19.4931 12.8398 19.4306 12.9023L18.1376 14.1953L13.1376 9.19531C12.8973 8.95514 12.5192 8.93634 12.2577 9.13965L12.1952 9.19531L9.99992 11.3896L5.13762 6.52832C4.8973 6.28833 4.51914 6.26946 4.25774 6.47266L4.19524 6.52832C3.95501 6.76854 3.93649 7.14669 4.13957 7.4082L4.19524 7.47168L9.52824 12.8047C9.76847 13.0449 10.1466 13.0634 10.4081 12.8604L10.4716 12.8047L12.6669 10.6104L17.1943 15.1387L15.9023 16.4307C15.7721 16.5608 15.7721 16.7722 15.9023 16.9023C15.9647 16.9648 16.0493 16.9999 16.1376 17H19.6669Z",
    fill: "#F20800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDecrease);
export default __webpack_public_path__ + "static/media/ArrowDecrease.c16cefec494c8a4d543791d1f401bf41.svg";
export { ForwardRef as ReactComponent };